import { vsingleton } from '@niknevis/vue-modules'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { Data } from '@/modules/shared/models/data'
import { VerificationStatusModel } from '@/modules/common/layout/components/panel/PanelLayout.vue'

export interface InitialPropsModel {
  message_board: any,
  current_user: Data<BasicUserResourceModel>,
  orig_user: string,
  wallet_amount: number,
  verification_status: VerificationStatusModel,
  unreadNotifications: number,
}

@vsingleton()
export default class InitialPropsStore {
  private initialPropsObject: InitialPropsModel
  _isMounted = false

  get isMounted(): boolean {
    return this._isMounted && !!this.initialPropsObject
  }

  set isMounted(value) {
    this._isMounted = value
  }

  get initialProps(): InitialPropsModel {
    return this.initialPropsObject
  }

  set initialProps(value: InitialPropsModel) {
    this.initialPropsObject = value
  }

  get phone() {
    return (this.initialPropsObject)
      ? this.initialPropsObject.current_user.data.phone
      : ''
  }

  get email() {
    return (this.initialPropsObject)
      ? this.initialPropsObject.current_user.data.email
      : ''
  }
}